import { IApplicationState } from '../../types/redux';
import { getFilters } from '../filters';
import { getDeveloper } from '../developer';

export const moscowCoords = { lat: 55.755814, lng: 37.617635 };
export const moscowZoom = 10;

export function getRegionCenterCoordinates(state: IApplicationState) {
  const { regionId } = getFilters(state);
  const developer = getDeveloper(state);
  const region = developer.regions.find(region => region.id === regionId);

  if (!region) {
    return { center: moscowCoords, zoom: moscowZoom };
  }

  const coordinates = region.centerCoordinates;

  const center = { lat: coordinates.lat, lng: coordinates.lng };

  if (!coordinates.zoom) {
    return { center, zoom: moscowZoom };
  }

  return { center: { lat: coordinates.lat, lng: coordinates.lng }, zoom: coordinates.zoom };
}
